import React from "react";
import { useNavigate } from 'react-router-dom';
import { Carousel } from "antd";
import "../styles/imageCarousel.css";

const ImageCarousel = ({ data }) => {
  const navigate = useNavigate();
  if (!data) return null;
  // Sort data by content_order
  const sortedData = [...data].sort(
    (a, b) => a.content_order - b.content_order
  );
  const handleNavigate = (collectionName,Category)=>{
    navigate(`collections/${collectionName}&attribute=${Category}`)
  }
  return (
    <Carousel
      arrows
      infinite={true}
      autoplay
      autoplaySpeed={4000}
      draggable={true}
      dotPosition="bottom"
      dots={{ className: "custom-dots" }} // Custom class for rounded dots
    >
      {sortedData.map((item, index) => {
        
        // Define inverted style for items 2 and 4
        const isInverted = index === 1 || index === 3;
        return (
          <div key={item.id} className="carousel-slide cursor-pointer">
            <div
              className="carousel-image bg-cover bg-center h-full relative"
              style={{
                backgroundImage: `url(${item.image})`,
              }}
            >
              <div
                className={`carousel-text absolute w-full md:w-1/3 right-10 top-2/3 transform -translate-y-1/2 ${
                  isInverted ? "text-black" : "text-white"
                } md:right-20 md:top-1/3 md:translate-y-0 md:translate-x-0 p-4 md:p-0`}
              >
                <h2
                  className={`text-3xl md:text-5xl font-bold mb-1 uppercase tracking-widest ${
                    isInverted ? "text-black" : "text-white"
                  }`}
                >
                  {item.name}
                </h2>
                <p
                  className={`text-lg md:text-2xl font-medium mb-4 md:mb-6 uppercase tracking-widest ${
                    isInverted ? "text-black" : "text-white"
                  }`}
                >
                  {item.description}
                </p>
                <button
                  onClick={() => handleNavigate(item.extras,item.name)}
                  className={`tracking-widest py-2 px-3 md:py-3 md:px-6 font-medium text-sm md:text-base rounded-md transition duration-300 ${
                    isInverted
                      ? "bg-black text-white hover:bg-gray-800"
                      : "bg-white text-black hover:bg-gray-300"
                  }`}
                  >
                  SHOP NOW
                </button>
              </div>
                  </div>
            </div>
        );
      })}
    </Carousel>
  );
};

export default ImageCarousel;
